import calcMilesPerYear from '@generic/functions/calcMilesPerYear';
import calcHoursPerYear from '@generic/functions/calcHoursPerYear';

const calcGallonsOfFossilFuelForVehicleSet = (vehicleSet) => {
  const {vehicle} = vehicleSet;

  return vehicle.category === 'On-Road'
    ? calcMilesPerYear(vehicleSet) / vehicle.fossilMilesPerGallon
    : calcHoursPerYear(vehicleSet) * vehicle.fossilGallonsPerHour; // Note that gallons are in the numerator here, hence multiplication rather than division
};

export default calcGallonsOfFossilFuelForVehicleSet;
